<section id="blog" class="py-5" appScrollReveal>
  <div class="container">
    <h2 class="section-title">Health Insights (Blog)</h2>
    <!-- Inline selected video (grid mode) -->
    <!-- Selected video: mobile uses standard iframe UI; desktop uses API player with custom controls -->
    <div *ngIf="currentVideoId && useStandardEmbedSelected" class="mb-3 position-relative selected-video-wrapper" aria-label="Selected video player">
      <div class="ratio ratio-16x9 rounded overflow-hidden shadow-sm">
        <iframe
          title="Selected video"
          width="100%"
          height="100%"
          style="border:0"
          loading="lazy"
          [src]="safeSelectedVideoUrl(currentVideoId)"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          playsinline
          allowfullscreen>
        </iframe>
      </div>
      <div class="d-flex mt-2">
        <button class="btn btn-sm btn-outline-danger ms-auto" (click)="closeVideo()">Close</button>
      </div>
    </div>
    
    <!-- Carousel mode when API key provided -->
    <div *ngIf="items?.length && carouselMode; else gridOrEmbed"></div>
    <ng-template #gridOrEmbed>
      <div *ngIf="items?.length && !carouselMode; else embedOrFallback">
        <div class="row g-3">
          <div class="col-6 col-md-3" *ngFor="let it of (items | slice:0:displayedLimit)">
            <div class="video-thumb card h-100 shadow-sm" (click)="selectVideo(it.videoId)" (touchstart)="selectVideo(it.videoId)" tabindex="0" (keyup.enter)="selectVideo(it.videoId)" role="button" [attr.aria-label]="'Play video ' + it.title" title="Play: {{it.title}}">
              <img [src]="it.thumbnail" [alt]="it.title" class="img-fluid rounded-top">
              <div class="card-body p-2">
                <div class="small text-truncate" title="{{it.title}}">{{it.title}}</div>
              </div>
            </div>
          </div>
        </div>
        <div #gridSentinel class="infinite-sentinel" aria-hidden="true"></div>
        <div class="mt-3 d-flex gap-2 flex-wrap">
          <button class="btn btn-sm btn-outline-primary" (click)="openPlaylist()">Open Full Playlist</button>
          <button *ngIf="(items?.length || 0) > displayedLimit" class="btn btn-sm btn-outline-secondary" (click)="showMore()">Show more</button>
        </div>
      </div>
    </ng-template>

    <ng-template #embedOrFallback>
      <div *ngIf="hasPlaylist; else postsFallback">
        <div class="ratio ratio-16x9 rounded overflow-hidden shadow-sm playlist-wrapper" (click)="openPlaylist()" title="Tap to open on YouTube if playback does not start">
          <iframe
            title="Clinic YouTube Playlist"
            width="100%"
            height="100%"
            style="border:0"
            loading="lazy"
            [src]="safePlaylistUrl"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            playsinline
            allowfullscreen>
          </iframe>
        </div>
        <p class="small text-muted mt-2 mb-0">New videos added to this playlist will appear here automatically.</p>
        <div class="mt-2">
          <a class="btn btn-sm btn-outline-primary" [href]="'https://www.youtube.com/playlist?list=' + playlistId" target="_blank" rel="noopener">
            Open Playlist on YouTube
          </a>
        </div>
      </div>
    </ng-template>

    <ng-template #postsFallback>
      <div class="row g-4">
        <div class="col-md-6 col-lg-3" *ngFor="let post of posts">
          <div class="card blog-card h-100 shadow-sm">
            <div class="card-body d-flex flex-column">
              <h6 class="fw-semibold mb-2">{{post.title}}</h6>
              <p class="small text-muted flex-grow-1 mb-3">{{post.excerpt}}</p>
              <a href="#" class="stretched-link small">Read more (coming soon)</a>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
  </div>
</section>
